
// export const MailroomHomeFaqs = [
//   // {
//   //   question: "How Does a Mailroom Work?",
//   //   answer:
//   //     "Some of the main features that differentiate us from our competitors are:",
//   //   list: [
//   //     "Elimination of manual entry",
//   //     "Ability to read handwriting",
//   //     "Superior search functionality",
//   //     "Collect a signature or photo for contactless delivery confirmation",
//   //     "No hardware required ",
//   //   ],
//   // },
//   {
//     question: "How Does a Mailroom Work?",
//     answer:
//       "Mailroom facilities are responsible for incoming and outgoing mail for a building/premises.<br/><br/>Normally, there is a mailroom clerk that processes deliveries, stores, and sorts them. For outgoing mail and packages, mail is prepared before it is sent out. <br/><br/>In larger facilities, mailrooms are a central point for collection and distribution of all internal mail and act as the primary POC with external mail.",
//   },
//   {
//     question: "What is the Mailroom of an Organization Devoted to?",
//     answer:
//       "The mailroom of an organization is an important facility devoted to handling inbound and outbound packages and mail deliveries. <br/><br/>These deliveries can be letters, small packages, larger packages, or even financial instruments. These items are then sorted by the mailroom staff and prepared for delivery to the final recipient.",
//   },
//   {
//     question: "What is Mailroom Management?",
//     answer: `Mailroom management is the processing of inbound and outbound mail within a mailroom facility. This can be for a multi-building complex such as a <a href="https://packagex.io/mailroom/industries/corporate/" target='_blank'>coworking space</a>, <a href="https://packagex.io/mailroom/industries/universities/" target='_blank'>university</a>, or a much smaller office space. <br/><br/>Usually, businesses make use of mailroom management software to cater to all mail handling needs for their facilities.<br/><br/>The <a href='https://packagex.io/mailroom-organization-tips-and-tricks/'target='_blank'>mailroom management process</a> includes but is not limited to:`,
//     list: [
//       "Receiving inbound mail",
//       "Processing it for storage",
//       "Notifying recipients about their packages",
//       "Ensuring package pick-up from the mailroom",
//       "Timely delivery of the packages",
//       "Processing outbound mail"
//     ],
//     answerSecond: "In a traditional mailroom, these processes are performed manually. <br/><br/>With a <a href='https://packagex.io/digital-mailrooms-guide/' target='_blank'>digital mailroom</a> management system, all these processes can be automated and digitally tracked, ensuring faster turnaround times, and reducing overall operational cost."
//   },
//   {
//     question: "What is Mailroom Software?",
//     answer:
//       "<a href='https://packagex.io/how-to-choose-the-right-mailroom-management-software-for-your-business/' target='_blank'>Mailroom software</a> is designed to automate most legwork involved with typical mailroom facilities. <br/><br/>Inbound package labeling, storage, notifications, and delivery to the recipient – most of these processes are automated with the help of mailroom software.",
//   },
//   {
//     question: "How to Scan Packages?",
//     answer:
//       "Packages are scanned using Optical Character Recognition (OCR) technology. Modern day mailroom management software such as PackageX Mailroom comes with OCR scanning capabilities out-of-the-box. <br/><br/>This allows mailroom software to scan QR codes, barcodes, and even handwritten labels. The <a href='https://packagex.io/new-osha-package-delivery-guidelines/' target='_blank'>package delivery processes</a> can be automated and simplified with the help of this technology. <br/><br/>The receipt of packages, storage, notifications, pickups, and more can be greatly optimized with a simple scan of the package label with a camera.",
//   },
// ]


export const MailroomHomeFaqs = [
  {
    question: "What is Mailroom?",
    answer:
      "Mailroom is a management software that helps you automate your mailroom. You can scan packages and notify the recipients, organize deliveries, keep entire record of the delivery, and much more with our user-friendly software.",
  },
  {
    question: "How does Mailroom work?",
    answer:
      "You don’t need extra hardware for the app to work. You can download our mobile app to get started. Mailroom uses your phone’s rear camera to scan the labels off the deliveries and notifies the recipients swiftly.",
  },
  {
    question: "What are the benefits of mailroom automation?",
    answer: `Equip your business with the cutting-edge technology and enjoy the benefits. Some of the <a href="https://packagex.io/blog/mailroom-management/digital-mailroom/" target="_blank" >benefits of a digital mailroom </a> are:`,
    list: [
      "Minimal Operational Costs",
      "More Storage for Deliveries",
      "Efficient Package Processing ",
      "Zero Lost Deliveries ",
      "Enhanced Customer Experience ",
    ],
  },
  {
    question: "Which devices are compatible with PackageX Mailroom? ",
    answer:
      "The PackageX Mailroom mobile app is compatible with iPhone SE onwards (6, 6s, 7, and so on), iPad and iPod models that are compatible with iOS 11 and greater, or any Android device that has a rear-facing camera and access to the Google Play Store. Moreover, you can use our desktop portal with any computer system.",
  },
  {
    question: "Can I try PackageX Mailroom?",
    answer:
      "Yes! You can sign-up for our 14-days free trial. Click the button below to get started.",
  },
]


export default MailroomHomeFaqs
